import Model from '@/models/Model'

export default class WhFamily extends Model {
    resource() {
        return 'wh_family'
    }
    static itemText() {
        return 'family'
    }
    static itemValue() {
        return 'id'
    }
}